import { render, staticRenderFns } from "./LicenceExpiration.vue?vue&type=template&id=7fd65048&scoped=true"
import script from "./LicenceExpiration.vue?vue&type=script&lang=js"
export * from "./LicenceExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd65048",
  null
  
)

export default component.exports